package one.healthium.promo_banner.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import loco.MAIN_BANNER_APP_PROMO_TITLE
import one.healthium.ui.compose.components.AppIcons
import one.healthium.ui.compose.components.AppText
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.koinInject

@Composable
fun PromoBanner(
    onClick: () -> Unit,
    modifier: Modifier = Modifier
) {
    val iconsProvider = koinInject<one.healthium.ui.compose.components.IconsProvider>()

    Row(
        modifier = modifier
            .fillMaxWidth()
            .clickable(onClick = onClick)
            .padding(16.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Box(
            modifier = Modifier.size(48.dp),
            contentAlignment = Alignment.Center
        ) {
            Icon(
                painter = painterResource(iconsProvider.appIcon),
                contentDescription = null,
                modifier = Modifier.size(48.dp),
                tint = Color.Unspecified
            )
        }

        Spacer(Modifier.width(16.dp))

        AppText(
            text = stringResource(loco.Res.string.MAIN_BANNER_APP_PROMO_TITLE),
            style = AppTheme.textStyles.secondary_16_500,
            color = AppTheme.colors.text100,
            modifier = Modifier.weight(1f)
        )

        Spacer(Modifier.width(8.dp))

        Image(
            painter = painterResource(AppIcons.icArrowRight),
            contentDescription = null,
            modifier = Modifier.size(13.dp),
        )
    }
}
